var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-row"},[_c('div',{staticClass:"header-box"},[_c('div',{staticStyle:{"display":"flex"}},[_c('nuxt-link',{staticClass:"logo",style:({backgroundImage:'url(/images/index/index-logo.png)'}),attrs:{"to":"/"}}),_vm._v(" "),_c('MainMenu')],1),_vm._v(" "),_c('UserOption')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }